<!--
 * @Author: Gaho
 * @Date: 2024-04-19 10:40:23
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-12 17:02:06
 * @Description: 目前用于 crash, circle 游戏显示某局的参加游戏的玩家列表 
-->
<template>
    <div class="round-lists">
        <q-table 
            hide-pagination
            row-key="name"
            :no-data-label="$t('Noinformation')"
            :rows="history.bets"
            :columns="columns"
            :pagination="{
                rowsPerPage: 0 // 0-无限
            }"
            v-if="history?.bets?.length"
        >
            <template v-slot:body="props">
                <q-tr :props="props">
                    <!-- ↓ 用户名，点击后有弹出窗口 -->
                    <q-td key="username">
                        <div @click="handleRowClick(props.row)"
                            class="cursor-pointer flex items-center"
                        >
                            <div class="user-avatar-container">
                                <UserAvatar
                                    size="22px"
                                    :src="props.row?.user?.avatar"
                                />
                                <span class="user-lvl">
                                    {{ props.row?.user?.lvl }}
                                </span>
                            </div>
                            <span class="td-username font-bold ml-2">
                                {{ props.row?.user?.name }}
                            </span>
                        </div>
                    </q-td>
                    <!-- ↓ 倍数 --> 
                    <q-td key="multi">
                        <span class="td-multi" :style="{ 'color': colors[props.row.sector] }">
                            <!-- ↓ 原版 crash 游戏尾部有 x，circle 游戏没有。这里都加上无妨 -->
                            {{ getFixed(props.row.multi) }}x
                        </span>
                    </q-td>
                    <!-- 下注金额 -->
                    <q-td key="amount">
                        <p class="td-amount">
                            <CurrentCoin :name="props.row.currency" class="flex w-[20px]" />
                            <span>
                                <!-- ${{ props.row.rateToUSD * props.row.amount }} -->
                                ${{ getFixed(props.row.amount) }}
                            </span>
                            <q-tooltip class="triangle" anchor="top start" self="bottom start">
                                <p class="td-amount">
                                    <CurrentCoin :name="props.row.currency" class="flex w-[20px]" />
                                    <span>
                                        ${{ getFixed(props.row.amount) }}
                                    </span>
                                </p>
                            </q-tooltip>
                        </p>
                    </q-td>
                    <!-- 分发 -->
                    <q-td key="rateToUSD">
                        <p class="td-amount">
                            <CurrentCoin :name="props.row.currency" class="flex w-[20px]" />
                            <span :class="props.row.winAmount > 0 ? 'won' : 'lost'">
                                <!-- ${{ props.row.winAmount * props.row.rateToUSD }} -->
                                ${{ getFixed(props.row.winAmount) }}
                            </span>
                            <q-tooltip class="triangle" anchor="top start" self="bottom start">
                                <p class="td-amount">
                                    <CurrentCoin :name="props.row.currency" class="flex w-[20px]" />
                                    <span>
                                        ${{ getFixed(props.row.winAmount) }}
                                    </span>
                                </p>
                            </q-tooltip>
                        </p>
                    </q-td>
                </q-tr>
            </template>
        </q-table>
        <p class="empty-page" v-else>
            {{$t('Noinformation')}}
        </p>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import { colors } from '@/components/Casino/History/GameContent/Circle.vue';
import 'quasar/src/components/table/QTable.sass'; 

const $i18n = useTranslation();
const props = defineProps({
    tableData: {
        type: Array,
        default: () => []
    },
    history: {
        type: Object,
        default: () => ({}),
    }
});
const columns = reactive([
    {
        name: 'Player',
        label: $i18n.GameDetails.Player,
        field: 'username',
        align: 'left'
    },
    { name: 'Multiplier', label: $i18n.Multiplier, field: 'multi', align: 'left' },
    { name: 'Bet amount', label: $i18n.BetAmount, field: 'amount', align: 'left' }, // rateToUSD * amount
    { name: 'Payout', label: $i18n.Payout, field: 'rateToUSD', align: 'left' }, // winAmount * rateToUSD
]) as any;

const emits = defineEmits(['onUpdateModelValue'])
/**
 * 打开用户信息弹框
 * @param row 当前下注信息
 */
const handleRowClick = (row) => {
    emits('onUpdateModelValue', row);
}
</script>

<style lang="scss" scoped>
.round-lists {
    :deep(.q-table__container){
        background: #111923;
        color: white;

        
        .q-table__top {
            padding: 12px 0;

            .q-table__title {
                font-size: 24px;
                font-weight: 700;
                letter-spacing: -.02em;
            }
        }

        .q-table__middle {
            max-height: 165px;
        }

        .no-data-message {
            width: 100%;
            text-align: center;
            color: #55657e;
            font-weight: 500;
            white-space: nowrap;
            font-size: 13px;
        }

        thead tr,
        th {
            height: 32px;
        }

        tbody tr,
        td {
            height: 44px;
        }

        tr {
            display: flex;
            width: 100%;
            align-items: center;
        }

        th {
            padding: 8px 0;
            color: #55657e;
            font-size: 11px;
            font-weight: 600;
            flex: 1;
            border-bottom: 1px solid #2a3546;
            font-size: 12px;

        }

        td {
            padding: 8px 0;
            font-size: 12px;
            font-weight: 600;
            line-height: 14px;
            white-space: pre-wrap;
            border-bottom: 1px solid #2a3546;
            flex: 1;
            overflow: hidden;
            display: flex;
            align-items: center;
            min-width: 120px;
        }
        .user-avatar-container {
            position: relative;
            display: inline-block; 
            .user-lvl {
                background-color: #55657e;
                border-radius: 50%;
                bottom: -4px;
                color: #fff;
                font-size: 10px;
                height: 15px;
                line-height: 15px;
                pointer-events: none;
                position: absolute;
                right: -4px;
                text-align: center;
                width: 15px;
            }
        }
    }
}
.td-amount {
    font-weight: 600;
    letter-spacing: -.5px;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #fff;

    img {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }
}
.empty-page {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 56px 0;
    font-weight: 600;
}
.won {
    color: rgb(27, 184, 61);
}
.lost {
    color: #55657e;
}
</style>